var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0556 5.2V4.5H11.6111V2.4H2.94444V12.2H6.55556V15H8.90278H8.72222C8.33913 15 7.97173 14.8525 7.70085 14.5899C7.42996 14.3274 7.27778 13.9713 7.27778 13.6V6.6C7.27778 6.2287 7.42996 5.8726 7.70085 5.61005C7.97173 5.3475 8.33913 5.2 8.72222 5.2H13.0556ZM8.90278 15H2.94444C2.56135 15 2.19395 14.8525 1.92307 14.5899C1.65218 14.3274 1.5 13.9713 1.5 13.6V2.4C1.5 1.63 2.15 1 2.94444 1H11.6111C11.9942 1 12.3616 1.1475 12.6325 1.41005C12.9034 1.6726 13.0556 2.0287 13.0556 2.4V5.2C13.4386 5.2 13.806 5.3475 14.0769 5.61005C14.3478 5.8726 14.5 6.2287 14.5 6.6V13.6C14.5 13.9713 14.3478 14.3274 14.0769 14.5899C13.806 14.8525 13.4386 15 13.0556 15H8.90278ZM8.72222 6.6V12.2H13.0556V6.6H8.72222ZM10.8889 14.3C11.0804 14.3 11.2641 14.2263 11.3996 14.095C11.535 13.9637 11.6111 13.7857 11.6111 13.6C11.6111 13.4143 11.535 13.2363 11.3996 13.105C11.2641 12.9737 11.0804 12.9 10.8889 12.9C10.6973 12.9 10.5136 12.9737 10.3782 13.105C10.2428 13.2363 10.1667 13.4143 10.1667 13.6C10.1667 13.7857 10.2428 13.9637 10.3782 14.095C10.5136 14.2263 10.6973 14.3 10.8889 14.3Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevice);
export default __webpack_public_path__ + "static/media/icon-device.0454f36a114b11658ece9f9073fe2f41.svg";
export { ForwardRef as ReactComponent };